import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

function ActivitiesLogs() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Activities Logs</Card.Title>
                <p className="card-category">
                  View system activity logs
                </p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <div className="content">
                  <p>Activities logs content goes here.</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ActivitiesLogs;